import React from 'react';
import {CreateGuesser} from "@api-platform/admin";

const AirlineInfoCreate = props => (
        <CreateGuesser {...props} resource="covid19-airline-infos"/>
);

export default AirlineInfoCreate;
